import React from 'react';
import './BuyerCard.scss';
import { getImageUrl } from '../../utils/imageUtils';

const BuyerCard = ({ buyer }) => {
  return (
    <div className="buyer-card">
      <div className="buyer-card__image">
        {buyer.image ? (
          <img src={getImageUrl(buyer.image)} alt={buyer.brand_name} />
        ) : (
          <div className="buyer-card__placeholder-image">
            {buyer.brand_name?.charAt(0).toUpperCase() || 'B'}
          </div>
        )}
      </div>
      <div className="buyer-card__content">
        <h3 className="buyer-card__name">{buyer.brand_name || 'Unknown'}</h3>
        <p className="buyer-card__location">{buyer.country || 'N/A'}</p>
        <p className="buyer-card__category">{buyer.category || 'N/A'}</p>
        
        <div className="buyer-card__footer">
          <div className="buyer-card__rating">
            <span className="buyer-card__rating-score">4.8</span>
            <span className="buyer-card__rating-icon">★</span>
          </div>
          <button className="buyer-card__contact-btn">Contact</button>
        </div>
      </div>
    </div>
  );
};

export default BuyerCard;
